export var TREE_VIEW_EXPAND_BEHAVIOR;
(function (TREE_VIEW_EXPAND_BEHAVIOR) {
    TREE_VIEW_EXPAND_BEHAVIOR["none"] = "none";
    TREE_VIEW_EXPAND_BEHAVIOR["expandToSelected"] = "expandToSelected";
    TREE_VIEW_EXPAND_BEHAVIOR["expandToChecked"] = "expandToChecked";
    TREE_VIEW_EXPAND_BEHAVIOR["expandToSelectedAndChecked"] = "expandToSelectedAndChecked";
    TREE_VIEW_EXPAND_BEHAVIOR["expandAll"] = "expandAll";
})(TREE_VIEW_EXPAND_BEHAVIOR || (TREE_VIEW_EXPAND_BEHAVIOR = {}));
export var TREE_VIEW_CHECK_BEHAVIOR;
(function (TREE_VIEW_CHECK_BEHAVIOR) {
    TREE_VIEW_CHECK_BEHAVIOR["simple"] = "simple";
    TREE_VIEW_CHECK_BEHAVIOR["hierarchical"] = "hierarchical";
    TREE_VIEW_CHECK_BEHAVIOR["descendantsHierarchical"] = "descendantsHierarchical";
    TREE_VIEW_CHECK_BEHAVIOR["fullHierarchical"] = "fullHierarchical";
})(TREE_VIEW_CHECK_BEHAVIOR || (TREE_VIEW_CHECK_BEHAVIOR = {}));
//# sourceMappingURL=types.js.map